export const truncateText = (text = "", maxLength = 60, options = {}) => {
  const { ellipsis = "..." } = options;
  const normalized =
    typeof text === "string" ? text : text == null ? "" : String(text);
  if (!normalized) {
    return { text: "", isTruncated: false };
  }

  const shouldTruncate = normalized.length > maxLength;
  if (!shouldTruncate) {
    return { text: normalized, isTruncated: false };
  }

  const clipped = normalized.slice(0, maxLength).trimEnd();
  return { text: `${clipped}${ellipsis}`, isTruncated: true };
};
